import React from 'react';
import { motion } from 'framer-motion';

export const Section = ({ id, children, className = '', bg = 'bg-brand-dark' }) => {
  return (
    <section id={id} className={`py-24 md:py-32 ${bg} ${className}`}>
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {children}
        </motion.div>
      </div>
    </section>
  );
};

export const SectionHeading = ({ children, className = '' }) => (
  <h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold text-brand-textHeading mb-12 tracking-tight text-balance ${className}`}>
    {children}
  </h2>
);